import React, { useEffect, useCallback } from 'react';
import {
  Card,
  CardContent,
  Grid,
  Typography,
  Button,
  FormHelperText,
} from '@mui/material';
import { Delete as DeleteIcon, Send as SendIcon } from '@mui/icons-material';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { Form } from 'react-final-form';

import { TextField } from '../common/Fields';
import { Content } from '../layout';

import {
  getMessageMacro,
  submitMessageMacro,
  updateMessageMacro,
  deleteMessageMacro,
} from '../../actions';

const MessageMacroForm = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();

  // const { messageMacro } = useSelector((state) => state.messageMacro);
  const { data, loading, error } = useSelector((state) => state.messageMacro);

  useEffect(() => {
    if (id) {
      dispatch(getMessageMacro(id));
    }
  }, [id, dispatch]);

  useEffect(() => {
    console.log('data', data);
  }, [data]);

  useEffect(() => {
    console.log('loading', loading);
  }, [loading]);

  const onSubmit = useCallback(
    (messageMacro) => {
      if (id) {
        dispatch(updateMessageMacro({ messageMacro, id })).then(() => {
          navigate('/messages/macros', { replace: true });
        });
      } else {
        dispatch(submitMessageMacro({ messageMacro })).then(() => {
          navigate('/messages/macros', { replace: true });
        });
      }
    },
    [id, dispatch, navigate]
  );

  const onDelete = useCallback(
    (e) => {
      e.preventDefault();
      dispatch(deleteMessageMacro({ id })).then(() => {
        navigate('/messages/macros', { replace: true });
      });
    },
    [id, dispatch, navigate]
  );

  return (
    <Form
      onSubmit={onSubmit}
      initialValues={{
        macroId: data?.macroId,
        subject: data?.subject,
        content: data?.content,
      }}
      validate={(values) => {
        const { macroId, subject, content } = values;
        const errors = {};
        // console.log('typeof macroId', typeof macroId);
        if (!macroId) {
          errors.macroId = '필수';
        } else if (isNaN(macroId)) {
          errors.macroId = '숫자로 입력해야 합니다.';
        }
        if (!subject) {
          errors.subject = '필수';
        }
        if (!content) {
          errors.content = '필수';
        }
        return errors;
      }}
      render={({
        submitError,
        handleSubmit,
        form,
        submitting,
        pristine,
        values,
      }) => (
        <Content>
          <form onSubmit={handleSubmit}>
            <Card>
              <CardContent>
                <Typography variant="h5" component="div">
                  메시지 매크로
                </Typography>

                <Grid
                  container
                  alignItems="flex-start"
                  spacing="20"
                  sx={{ mt: 2 }}
                >
                  <Grid item xs={12}>
                    <TextField
                      required={true}
                      variant="standard"
                      name="macroId"
                      type="number"
                      label="매크로 ID"
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <TextField
                      variant="standard"
                      name="subject"
                      type="text"
                      label="제목"
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      variant="standard"
                      name="content"
                      type="text"
                      label="내용"
                      // textarea={true}
                      multiline
                      rows={4}
                    />
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
            {submitError && <FormHelperText>{submitError}</FormHelperText>}
            <Grid container sx={{ mt: 2 }}>
              <Grid item xs={6}>
                {id && (
                  <Button
                    variant="outlined"
                    color="error"
                    startIcon={<DeleteIcon />}
                    onClick={onDelete}
                  >
                    삭제
                  </Button>
                )}
              </Grid>
              <Grid item xs={6} container justifyContent="flex-end">
                <Button
                  variant="contained"
                  endIcon={<SendIcon />}
                  type="submit"
                >
                  저장
                </Button>
              </Grid>
            </Grid>
          </form>
        </Content>
      )}
    />
  );
};

export default MessageMacroForm;
